import { compose, hoistStatics, withState, lifecycle, withHandlers, withPropsOnChange, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import Manage from './Manage';
import WithLoading from '../../../components/WithLoading';
import { messageActions, messageOperations } from '../../../reducers/messages';
import ModuleService from '../../../services/module.service';
import ChannelsService from '../../../services/channels.service';

const defaultSearchedData = { data: [], count: 0, hasMore: false, hasLoaded: false }

class RefsStore {
  store(name, value) {
    this[name] = value;
  }
}

const messageSearchCallback = props => async (value, offset) => {
  const { setSearchedData, searchedData } = props;
  if (!offset) {
    setSearchedData({ hasLoaded: false, data: [] });
  }
  if (value) {
    const limit = 10;
    const { data: { data, count, hasMore } } = await ChannelsService.search({ search: value, limit, offset });
    let newData;
    if (offset) {
      newData = searchedData.data.concat(data);
    } else {
      newData = data;
    }
    setSearchedData({ data: newData, count, hasMore, offset: offset + limit, hasLoaded: true });
  }
};

const callback = props => (value) => {
  props.setSearchedValue(value);
  messageSearchCallback(props)(value, 0);
  if (props.refs && props.refs.listConv) {
    props.refs.listConv.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  }
};

const startChat = props => async (e, id) => {
  if (e) e.preventDefault();
  props.history.push(`/messages/${id}`);
};

const startChatWithSearch = ({ history, setSearchMessage, setSearchedData }) => (e, message) => {
  e.preventDefault();
  history.push(`/messages/${message.id}`);
  setSearchMessage(message);
  setSearchedData(defaultSearchedData);
};

const startChatCallback = props => (e, msg) => {
  e.preventDefault();
  const { changeSearchCallback, setChangeSearchCallback, setSearchedValue } = props;
  setSearchedValue('');
  startChatWithSearch(props)(e, msg);
  setChangeSearchCallback(!changeSearchCallback);
};

const loadMore = props => () => {
  const { searchedData, searchedValue } = props
  if (searchedData.hasMore) {
    messageSearchCallback(props)(searchedValue, searchedData.offset);
  }
};

const getChannelName = ({ subscriber }) => (channel) => {
  let chatName = '';

  if (channel) {
    if (channel.type === ChannelsService.TYPE_SUPPORT && subscriber) {
      const { title, name } = subscriber;
      chatName = title || name;
    } else chatName = channel.channelName;
  }

  return chatName || channel.name;
};
const mapStateToProps = state => ({
  token: state.user.token,
  newMessageIn: state.messenger.newMessageIn,
  modulesSettings: state.modules.modulesSettings,
  subscriber: state.settings.subscriber,
});

const mapDispatchToProps = ({
  emitNewMessage: messageOperations.emitNewMessage,
  onTyping: messageOperations.onTyping,
  addChat: messageActions.addChat,
  clearMessenger: messageActions.clearMessenger,
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'setIsLoading', true),
  withState('searchMessage', 'setSearchMessage', null),
  withState('messageCriteria', 'setMessageCriteria', { limit: 10 }),
  withState('searchedValue', 'setSearchedValue', ''),
  withState('changeSearchCallback', 'setChangeSearchCallback', true),
  withState('searchedData', 'setSearchedData', defaultSearchedData),
  translate('portal'),
  lifecycle({
    async componentDidMount() {
      this.props.setIsLoading(false);
    },
    componentWillUnmount() {
      this.props.clearMessenger();
    },
  }),
  withPropsOnChange(['newMessageIn'], (props) => {
    if (props.newMessageIn) {
      startChat(props)(null, props.newMessageIn);
    }
  }),
  withProps(props => ({
    moduleTitle: props.modulesSettings[ModuleService.TYPE_MESSAGE].title || props.t('Messages'),
    backgroundColor: props.modulesSettings[ModuleService.TYPE_MESSAGE].color ?
      props.modulesSettings[ModuleService.TYPE_MESSAGE].color : props.modulesSettings[ModuleService.TYPE_MESSAGE].default_color,
    backgroundCover: props.modulesSettings[ModuleService.TYPE_MESSAGE].cover,
    refs: new RefsStore(),
    enableCoverColor: props.modulesSettings.enable_cover_color,
  })),
  withHandlers({
    startChat,
    callback,
    getChannelName,
    startChatWithSearch,
    startChatCallback,
    loadMore,
  }),
);
export default hoistStatics(enhance)(WithLoading(Manage));



// WEBPACK FOOTER //
// ./src/views/modules/messages/index.js